package br.com.vvrefeicoes.portal.navigation

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("login")
data object LoginRoute

@Serializable
@SerialName("esqueci-minha-senha")
data object ForgotPasswordRoute

@Serializable
@SerialName("inicio")
data object HomeRoute

@Serializable
@SerialName("administracao/unidades")
data object AdminCompaniesRoute

@Serializable
@SerialName("ferramentas/empresas-cnpj")
data object JuridicoEmpresasRoute

@Serializable
@SerialName("juridico/oficiais-e-tribunais")
data object JuridicoOfficersCourtsRoute

@Serializable
@SerialName("administracao/usuarios")
data object AdminUsersRoute

@Serializable
@SerialName("administracao/auditoria")
data object AdminAuditRoute

@Serializable
@SerialName("organograma")
data object OrgChartRoute

@Serializable
@SerialName("notificacoes")
data object NotificationsRoute

@Serializable
@SerialName("comunicados")
data object AnnouncementsRoute

@Serializable
@SerialName("saude-do-sistema")
data object SystemHealthRoute

@Serializable
@SerialName("guias-e-manuais")
data object GuidesAndManualsRoute

@Serializable
@SerialName("guias-e-manuais/{id}")
data class GuideDetailRoute(
    val id: String,
)

@Serializable
@SerialName("guias-e-manuais/novo")
data object GuideCreateRoute

@Serializable
@SerialName("guias-e-manuais/{id}/editar")
data class GuideEditRoute(
    val id: String,
)

@Serializable
@SerialName("perfil")
data object ProfileRoute

@Serializable
@SerialName("operacional/painel")
data object OperationalPanelRoute

@Serializable
@SerialName("operacional/lancamentos")
data object OperationalEntriesRoute

@Serializable
@SerialName("rh/painel")
data object RhPanelRoute

@Serializable
@SerialName("rh/lancamentos")
data object RhEntriesRoute

@Serializable
@SerialName("comercial")
data object CommercialRoute

@Serializable
@SerialName("ferramentas/food-pass/clientes")
data object FoodPassClientsRoute

@Serializable
@SerialName("ferramentas/food-pass/consumos")
data object FoodPassConsumptionsRoute

@Serializable
@SerialName("ferramentas/food-pass/faturamento")
data object FoodPassBillingRoute

@Serializable
@SerialName("ferramentas/redes-sociais")
data object SocialConnectionsRoute

@Serializable
@SerialName("ferramentas/satisfaction/relatorios")
data object SatisfactionReportsRoute

@Serializable
@SerialName("ferramentas/satisfaction/status-operacao")
data object SatisfactionOperationStatusRoute

@Serializable
@SerialName("formularios")
data object FormulariosRoute

@Serializable
@SerialName("formularios/criar")
data object FormularioCreateRoute

@Serializable
@SerialName("formularios/{id}")
data class FormularioViewRoute(
    val id: String,
)

@Serializable
@SerialName("formularios/editar/{id}")
data class FormularioEditRoute(
    val id: String,
)

@Serializable
@SerialName("compras")
data object PurchasesRoute

@Serializable
@SerialName("compras/lancamentos")
data object PurchasesEntriesRoute

@Serializable
@SerialName("rh/rmp")
data object RmpRoute

@Serializable
@SerialName("rh/novo-rmp")
data object RmpNewRoute

@Serializable
@SerialName("rh/rmp/{id}/editar")
data class RmpEditRoute(
    val id: String,
)

@Serializable
@SerialName("rh/rmp-sync")
data object RmpSyncRoute

@Serializable
@SerialName("politica-de-privacidade")
data object PrivacyPolicyRoute

@Serializable
@SerialName("monitor_pesquisa")
data class PublicMonitorRoute(
    val code: String,
)
